import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { Text } from 'library';
import { useUserContext } from 'UserContext';
import HowItWorks from './components/HowItWorks';
import theme from 'theme';
import Guides from './components/Guides';
import PostJob from './dashboard/PostJob';
import BusinessNotifications from './dashboard/BusinessNotifications';
import DayCareCenterList from './dashboard/DayCareCenterList';
import WorkerTimeSheets from './dashboard/WorkerTimeSheets';
import ProviderReviewList from './dashboard/ProviderReviewList';
import type { IBusinessDashboardProps } from './dashboard/types';

const BusinessDashboard = ({ data, updateData }: IBusinessDashboardProps) => {
    const { user } = useUserContext();
    const mdUp = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Grid container spacing={2} style={{ padding: mdUp ? 46 : 10 }}>
            <Grid item sm={6} xs={12}>
                <Text variant="display" textStyle={{ paddingLeft: 20 }}>
                    Welcome {user ? user.first_name : 'User'}!
                </Text>
                <PostJob />
                <WorkerTimeSheets data={data} updateData={updateData} />
                <ProviderReviewList />
            </Grid>

            <Grid item sm={6} xs={12}>
                <Grid container>
                    <BusinessNotifications data={data} />
                    <DayCareCenterList data={data} />
                    <HowItWorks />
                    <Guides data={data} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BusinessDashboard;
